<template>
    <canvas ref="chart" width="200" height="200" />
</template>

<script>
    import { onMounted, ref } from 'vue'
    import {
        Chart,
        ArcElement,
        DoughnutController,
        LinearScale,
    } from 'chart.js'

    Chart.register(
        ArcElement,
        DoughnutController,
        LinearScale,
    )

    export default {
        props: {
            rating: Number,
        },

        setup(props) {
            const chart = ref(null)
            const parameters = {
                type: 'doughnut',
                data: {
                    datasets: [{
                        data: [props.rating, 100 - props.rating],
                        backgroundColor: [
                            '#22C45D',
                            '#FFFFFF',
                        ]
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    events: []
                },
                plugins: [{
                    id: 'text',
                    beforeDraw: function(chart) {
                        const width = chart.width,
                            height = chart.height,
                            ctx = chart.ctx
                        const fontSize = (height / 114).toFixed(2)

                        ctx.restore()

                        ctx.font = fontSize + 'em Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji'
                        ctx.textBaseline = 'middle'
                        ctx.fillStyle = '#101827'

                        const text = (props.rating / 10).toFixed(1),
                            textX = Math.round((width - ctx.measureText(text).width) / 2),
                            textY = height / 2 + 3

                        ctx.fillText(text, textX, textY)
                        ctx.save()
                    }
                }]
            }

            onMounted(() => {
                new Chart(chart.value, parameters)
            })

            return {
                chart,
            }
        }
    }
</script>